@if(user) {
<h1>Welkom {{ user.displayName }} </h1>
<span><img [src]="profilePhoto" alt="user picture" height="100px"/></span>
}